import type { CursorPaginationResponse, QueryParams } from '~/services/api';
import type { AxiosPromise } from 'axios';
import type { BaseClientConfig, ExtendedAxiosRequestConfig } from '~/services/BaseClient';

export const threadsClientConfig: BaseClientConfig = {
    apiBase: window.Spark?.apiBase,
};

export interface Thread {
    team_id: number;
    contact_id: number;
    contact_name?: string;
    contact_phone?: string;
    message_count?: number;
    group_id?: string;
    status: string;
    last_message_id?: number;
    last_message_content?: string;
    last_message_direction?: string;
    last_message_at?: string;
    thread_claim_id?: number | null;
    assignee_id: number | null;
    unread: number;
    created_at?: string;
    updated_at?: string;
}

export interface ThreadsSummary {
    me?: number;
    unassigned?: number;
    open?: number;
    closed?: number;
    all?: number;
}

export interface ThreadsGetParams extends QueryParams {
    status?: string;
    forward?: string;
    assignee?: number;
    tag?: string;
    search?: string;
    email?: string;
    phone?: string;
    contact_id?: number;
}

export interface AssignPayload {
    assignee_id: number;
}

export interface CheckpointResponse {
    message_count?: number;
}

export interface ThreadsClientInterface {
    getThreads(
        params?: ThreadsGetParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<Thread>>;

    getSummary(config?: ExtendedAxiosRequestConfig): AxiosPromise<ThreadsSummary>;

    setState(contactId: number, state: string, groupId?: string): AxiosPromise<void>;

    assignToSelf(contactId: number, groupId?: string): AxiosPromise<void>;

    assignTo(contactId: number, payload: AssignPayload, groupId?: string): AxiosPromise<void>;

    unclaim(contactId: number, groupId?: string): AxiosPromise<void>;

    checkpointSave(contactId: number, groupId?: string): AxiosPromise<CheckpointResponse>;

    checkpointDelete(contactId: number, groupId?: string): AxiosPromise<CheckpointResponse>;

    checkpointGet(contactId: number, groupId?: string): AxiosPromise<CheckpointResponse>;
}
